import { Component } from '@angular/core';

@Component({
  selector: 'ngx-criteres',
  template: `<router-outlet></router-outlet>`,
})
export class CriteresComponent {
}
